export default __webpack_public_path__ + "static/media/IMG_3561.da7419c3.jpg";